export class Configs {
    static APP_NAME = 'SendPouch';
    static GATEWAY_SERVICE_URL = process.env.REACT_APP_GATEWAY_SERVICE_URL;
    static MAIL_SERVICE_URL = process.env.REACT_APP_MAIL_SERVICE_URL;
    static STUDIO_URL = process.env.REACT_APP_STUDIO_URL;
}